import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminGroupListService {
  onGroupFilterChange = new Subject<any>();
  onParticipantCaregiverFilterChange = new Subject<{
    groupId?: number[],
    role?: number[],
    status?: number[],
    searchText?: string,
  }>();

  onParticipantWeightInformationFilterChange = new Subject<{
    clientId?: number[],
    groupId?: number[],
    session?: number,
    status?: number[],
    searchText?: string,
  }>();

  onParticipantBehaviourInformationFilterChange = new Subject<{
    groupId?: number,
    role?: number[],
    session?: number,
    status?: number[],
    searchText?: string,
  }>();

  constructor() {
  }
}
